import { createElement } from 'react';
import {
  joinClasses,
  BESPOKE_SECTION_LABEL_CLASS,
  BESPOKE_TITLE_LABEL_CLASS,
} from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { StaticTextElement, LayoutInlineStyle } from '../types';

export function StaticTextBlock({
  text,
  as,
  variant,
  className,
  style,
}: {
  text: string;
  as: StaticTextElement;
  variant?: 'section' | 'title' | 'hint';
  className?: string;
  style?: LayoutInlineStyle;
}) {
  const STATIC_TEXT_VARIANT_CLASS: Record<
    'section' | 'title' | 'hint',
    string
  > = {
    section: BESPOKE_SECTION_LABEL_CLASS,
    title: BESPOKE_TITLE_LABEL_CLASS,
    hint: 'text-xs font-normal leading-snug text-muted-foreground',
  };

  return createElement(
    as,
    {
      className: joinClasses(
        variant != null ? STATIC_TEXT_VARIANT_CLASS[variant] : undefined,
        className
      ),
      style: layoutInlineStyle(style),
    },
    text
  );
}
